module.exports = "pegasus_template/assets/preview.png";